/**
 * Dietary tags — the `dietary_tags` ACF checkbox (return_format: label),
 * mirror of HOTEL_MENU_EDIT_DIETARY and acf-json/group_dish.json.
 * The stored value IS the label (no separate slug).
 */
export const DIETARY_TAGS = [
  'Végétarien',
  'Vegan',
  'Sans gluten',
  'Halal',
  'Sans lactose',
  'Sans porc',
] as const;

export type DietaryTag = (typeof DIETARY_TAGS)[number];
